<app-layout-grid [details]="details"></app-layout-grid>
<ng-template #details>
  <nz-card nzType="inner">
    <app-organisation-detail></app-organisation-detail>
  </nz-card>
</ng-template>
